(function () {

    angular
        .module('smartertoolsApp')
        .config(['$routeProvider', smarterToolsRouteProvider])
        .run(['$rootScope', function ($rootScope) {
            $rootScope.$on('$stateChangeSuccess', () => {
                window.scrollTo(0, 0);
            });
            $rootScope.$on('$routeChangeSuccess', (event, currentRoute, previousRoute) => {
                window.scrollTo(0, 0);
            });
        }]);

    function smarterToolsRouteProvider($routeProvider) {
        $routeProvider
            .when('/',
                {
                    templateUrl: '/app/smartertrack-signup/signup-form.html',
                    controller: 'trackSignupForm as signup'
                })
            .when('/:sitePrefix/:guid',
                {
                    templateUrl: '/app/smartertrack-signup/signup-progress.html',
                    controller: 'trackSignupProgress as signupProgress'
                })
            .otherwise({
                redirectTo: '/'
            });
    }

})();